import React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import dayjs from 'dayjs';

const DatePickerComp = ({
                            value,
                            onChange,
                            onClear,
                            maxNextDay = true,
                            width = 160,
                        }) => {

    const today = dayjs();
    const nextDay = today.add(1, "day");

    const shouldDisableDate = (date) => {
        if (!maxNextDay) return false;
        return date?.isAfter(nextDay);
    };

    const handleChangeDate = (date) => {
        if (date && onChange) {
            onChange(dayjs(date));
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DesktopDatePicker
                value={value}
                onChange={handleChangeDate}
                yearsPerRow={4}
                closeOnSelect
                mask="__.__.____"
                format="DD/MM/YYYY"
                shouldDisableDate={shouldDisableDate}
                sx={{
                    width: width,
                    marginLeft: '25px',
                    '& .MuiInputBase-input': {
                        textAlign:'left'
                    },
                }}
                slotProps={{
                    field: {
                        clearable: true,
                        onClear: onClear
                    },
                    textField: {
                        variant: 'standard',
                        placeholder: dayjs().format('DD/MM/YYYY'),
                        inputProps: {
                            disabled: true,
                            sx: {
                                textAlign: 'center'
                            }
                        },
                    },
                }}
            />
        </LocalizationProvider>
    );
};

export default DatePickerComp;